






























































import Vue from "vue";
import {
  AInput,
  Dropdown,
  ACalendar,
  AFormItem,
} from "@canvas/componentlibrary";
import { mapActions, mapState } from "vuex";
import { getErrorMsg } from "@/types";
import { Form, CustomRenderers } from "@canvas/vuejsonschemaform";

export default Vue.extend({
  components: {
    AInput,
    ACalendar,
    AFormItem,
    Form,
  },
  data(): { [key: string]: any } {
    return {
      projectDetailFormStructure: {},
      formInitialData: null,
      dropdownOpen: false,
      onHoldReason: null,
      saveBtn: {
        isDisabled: false,
        text: "Submit",
      },
      selectedDate: null,
      comments: "",
      onHoldReasonOptions: [],
      validateStatus: {
        reason: "",
        date: "",
      },
    };
  },
  computed: {
    ...mapState("appModule", {
      partialProject: "partialProject",
      selectedEc: "selectedEc",
    }),
    hasFormStructure(): boolean {
      return Object.keys(this.projectDetailFormStructure).length > 0;
    },
    renderers() {
      (CustomRenderers["*"] as any) = {
        ...CustomRenderers["*"],
      };
      return CustomRenderers;
    },
  },
  methods: {
    ...mapActions("appModule", [
      "getOnHoldReasons",
      "submitOnHold",
      "createProject",
      "getFormStructureSchema",
    ]),
    updateReason(item: any) {
      this.onHoldReason = item;
      this.validateStatus.reason = "success";
    },
    customDatePreidctor(val: string | number | Date) {
      const currentDate = new Date();
      const selectedDate = new Date(val);
      return selectedDate < currentDate;
    },
    setSelectedDate(date: any) {
      this.selectedDate = date;
      this.validateStatus.date = "success";
    },
    validateAndSetError(formData: any, form: any, attribute: string) {
      if (formData.attribute_data[attribute].length === 0) {
        // @ts-ignore
        form.formdata.statuses.attribute_data[attribute] = "error";
      }
    },
    async goToNextStep() {
      try {
        let formdata_project: any = {};
        if (this.hasFormStructure) {
          const form = (this as any).$refs.form2 as Form;
          formdata_project = form.getFormData();
          this.validateAndSetError(
            formdata_project,
            form,
            "know_about_livspace"
          );
          this.validateAndSetError(
            formdata_project,
            form,
            "know_about_experience_center"
          );
        }
        this.clearValidationStatus();
        if (!this.onHoldReason) {
          this.setValidationError("reason");
        }
        if (!this.selectedDate) {
          this.setValidationError("date");
        }
        if (this.hasValidationError()) {
          return;
        }
        const projectDetails = await (this as any).createProject(
          Object.assign(formdata_project, {
            ec_id: (this as any).selectedEc.name,
          })
        );
        const isoString = this.getIsoStringFromDate(this.selectedDate);
        await this.submitOnHold({
          status: "ONHOLD",
          onhold_reason: this.onHoldReason.name,
          status_change_reason: this.comments,
          on_hold_till: isoString,
        });
        (this as any).$store.dispatch("uiModule/addToast", {
          severity: "success",
          message: "Project updated to OnHold",
        });
        this.$router.push({
          path:
            "/lead/" +
            this.$router.currentRoute.params.lead_id +
            "/" +
            this.partialProject.project_id +
            "/assignment",
        });
      } catch (err) {
        (this as any).$store.dispatch("uiModule/addToast", {
          severity: "error",
          message: getErrorMsg(err),
        });
      }
    },
    setValidationError(field: string) {
      this.validateStatus[field] = "error";
    },
    getIsoStringFromDate(date: string | number | Date) {
      return new Date(date).toISOString();
    },
    clearValidationStatus() {
      this.validateStatus = {
        reason: "",
        date: "",
      };
    },
    hasValidationError() {
      return Object.values(this.validateStatus).some(
        (status) => status === "error"
      );
    },
    handleInput(event: any) {
      this.comments = event;
    },
  },
  async mounted() {
    const onHoldInactiveReasons = await (this as any).getFormStructureSchema(
      "onHold_inActive_reasons"
    );
    this.onHoldReasonOptions = onHoldInactiveReasons.onhold_reasons;
    this.projectDetailFormStructure = await (this as any).getFormStructureSchema(
      "onHold_inActive_project_details"
    );
  },
});
